/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface GCPDatabaseUserPermissionsRequest {
  permissions?: Array<GCPDatabaseUserPermissionsRequest.PermissionsEnum>;
}
export namespace GCPDatabaseUserPermissionsRequest {
  export type PermissionsEnum = 'SELECT' | 'INSERT' | 'UPDATE' | 'DELETE';
  export const PermissionsEnum = {
    SELECT: 'SELECT' as PermissionsEnum,
    INSERT: 'INSERT' as PermissionsEnum,
    UPDATE: 'UPDATE' as PermissionsEnum,
    DELETE: 'DELETE' as PermissionsEnum
  };
}
